function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  .MuiOutlinedInput-input {\n    background: transparent;\n    border: none;\n    height: 100%;\n    width: 100%;\n    padding: 11px 16px 11px 0;\n    font-size: ", ";\n    color: ", ";\n  }\n  .MuiOutlinedInput-root {\n    border-radius: 2px;\n    width: 100%;\n    box-sizing: border-box;\n    padding-left: 15px;\n    color: ", ";\n    &:focus {\n      & .MuiOutlinedInput-notchedOutline {\n        border: none;\n      }\n    }\n    &:hover {\n      & .MuiOutlinedInput-notchedOutline {\n        border-color: ", ";\n      }\n    }\n    &.Mui-focused {\n      & .MuiOutlinedInput-notchedOutline {\n        border: 1px solid ", ";\n      }\n    }\n    &.Mui-disabled {\n      pointer-events: none;\n      opacity: 0.4;\n    }\n  }\n  .MuiOutlinedInput-notchedOutline {\n    border: 1px solid ", ";\n    &:focus {\n      border: 1px solid ", ";\n      outline: none;\n    }\n  }\n  .error {\n    .MuiOutlinedInput-notchedOutline {\n      border: 1px solid ", ";\n    }\n  }\n  .hideBorder {\n    .MuiOutlinedInput-notchedOutline {\n      border: none;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { StylesProvider } from '@material-ui/styles';
import DateFnsUtils from '@date-io/date-fns';
import { defaultTheme } from '../../../utils';
var DatePickerInputContainer = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.typeScale.regular;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.textColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.textColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.primaryBorder;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.primaryBorderActive;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.primaryBorder;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.primaryBorderActive;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.status.errorColor;
});

var DatePickerInput = function DatePickerInput(_ref9) {
  var inputRef = _ref9.inputRef,
      name = _ref9.name,
      styleClass = _ref9.styleClass,
      hideBorder = _ref9.hideBorder,
      rest = _objectWithoutPropertiesLoose(_ref9, ["inputRef", "name", "styleClass", "hideBorder"]);

  return /*#__PURE__*/React.createElement(StylesProvider, {
    injectFirst: true
  }, /*#__PURE__*/React.createElement(DatePickerInputContainer, rest, /*#__PURE__*/React.createElement(MuiPickersUtilsProvider, {
    utils: DateFnsUtils
  }, /*#__PURE__*/React.createElement(KeyboardDatePicker, _extends({
    id: "date-picker",
    format: "yyyy/MM/dd",
    name: name,
    className: hideBorder ? 'hideBorder' : "" + styleClass,
    autoOk: true,
    inputVariant: "outlined",
    inputRef: inputRef
  }, rest)))));
};

DatePickerInput.propTypes = process.env.NODE_ENV !== "production" ? {
  inputRef: PropTypes.func,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  styleClass: PropTypes.string
} : {};
DatePickerInput.defaultProps = {
  name: '',
  inputRef: function inputRef() {},
  styleClass: '',
  theme: defaultTheme
};
export default DatePickerInput;